import AppleWebPushConfig from './static/apple-pushpackage/website.json';
import {z} from 'zod';

export default {

	// domain lang (html lang=) and other use
	lang: 'ro',

	// main domain name, used for redirects, content etc.
	domain: 'okmagazine.ro',

	// alternate domain name , this is usually the cdn cname alias for cdn
	// used for loading videoplayer for use within amp (which requires a different domain than the main domain)
	alternateDomain: 'okmagazine-ro.adh.reperio.news',

	// used as display in various places
	friendlyName: 'OkMagazine',
	friendlyURL: 'https://okmagazine.ro',
	logoURL: 'https://okmagazine.ro/favicon-144-precomposed.png',

	paginationLimitPerPage: 60,

	// is this "ajax" site, svelte auto hydrate pages?
	hydrate: false,

	// xxx: is this still valid? type of articles to publish (grouping basically for custom logic), optional
	// content_type: ['article', 'blog_post'],

	// auto load data for this blocks and include in all pages (headers, footers, etc)
	// this is usefull if publishers wants to auto include via code specific blocks in the page.
	autoLoadGlobalBlocks: ['TopMenu_main_menu', 'Footer_footer', 'AdPosition_head', 'AdPosition_body_end'],

	// regex redirects on the front-end renderer
	redirects: {

		'\/\/www\.okmagazine\.ro\/(.*)': {
			url: 'https://okmagazine.ro/$1',
			status: 301
		},

		'.*/rss.xml': {
			url: 'https://okmagazine.ro/rss/index',
			status: 301,
		},

		'.*\/a(\\d{1,})$': {
			url: 'https://okmagazine.ro/article_old/$1',
			status: 301,
		},

		'.*\\/rd\-(\\d{1,})$': {
			url: 'https://okmagazine.ro/article_old/$1',
			status: 301,
		},

		'/ads.txt': {
			url: 'https://adstxt.dev/de538d803a/ads.txt',
			status: 302,
		}

	},

	appleWebPushConfig: AppleWebPushConfig,
	customContentFields: z.object({
		ads_disabled: z.boolean().optional(),
	}),

	customCategoryFields: z.object({
		ads_disabled: z.boolean().optional(),
	}),

}

export const MISC = {
	logo: {
		width: 164,
		height: 99,
	},

	menuDefaultcolor: "#ffffff",
	menuBorderColor: "#dddddd",
	boxColor: "#C80D11",
	boxColorLight: "#fff",
	menuFontColor: "#111111",
	headingsColor: "#000000",
	headingsBorderColor: "#111",
	headingsBgColor: "none",
};

// Tags consumed by this theme's components as behavior flags or display
// badges rather than topics (ads/comments switches, title badges). The
// admin's tag assistant must neither suggest nor critique them.
export const SYSTEM_TAGS = [
	"noads",
	"sex",
	"advert",
	"advertorial",
];
